import { MobDef } from '../mob';
import { BlockId } from '@shared/block-ids';

export const CHICKEN_DEF: MobDef = {
  name: 'Chicken',
  width: 0.3,
  height: 0.6,
  health: 4,
  speed: 1.8,
  hostile: false,
  color: 0xeeeeee,
  bodyColor: 0xdddddd,
  detectionRange: 0,
  attackDamage: 0,
  attackRange: 0,
  drops: [
    { id: BlockId.SAND, min: 1, max: 2 }, // feather placeholder (using sand)
  ],
};
